type Listener = (token: string | null) => void;

let accessToken: string | null = null;
const listeners = new Set<Listener>();

/**
 * Access token sống **trong memory**, không phải `localStorage` —
 * docs/security.md §2.
 *
 * `localStorage` đọc được bằng JavaScript, nên bất kỳ XSS nào cũng lấy được
 * token và giữ nó vô thời hạn. Biến trong module thì mất khi reload tab —
 * đúng như mong muốn: reload sẽ xin token mới bằng refresh cookie `httpOnly`,
 * thứ mà JavaScript không đọc được.
 *
 * Nằm ngoài React vì `http.ts` cần đọc nó ở tầng không có hook.
 */
export const tokenStore = {
  get(): string | null {
    return accessToken;
  },

  set(next: string | null): void {
    if (accessToken === next) return;
    accessToken = next;
    for (const listener of listeners) listener(next);
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  /** Chỉ dùng trong test. */
  reset(): void {
    accessToken = null;
    listeners.clear();
  },
};
